// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2141":"b137d96b46662c1f","4112":"a3ede44e6a0beb25","5735":"8f9664763c978741","8787":"a1e3a7d3afb0d21c"}[chunkId] + ".css";
};